import {ActionCreatorDefinition, createAction} from "redux-ts";
import {InboxMessage, PushNotification} from "core/redux/inbox/InboxReduxState";

export const AddInboxMessageType: string =  "AddInboxMessage";
export const RemoveInboxMessageType: string =  "RemoveInboxMessage";
export const ResetInboxUnreadCountType: string =  "ResetInboxUnreadCount";
export const SetPushNotificationType: string = "SetPushNotification";
export const RemovePushNotificationType: string = "RemovePushNotification";

export interface AddInboxMessagePayload {

    message: InboxMessage;
}

export interface RemoveInboxMessagePayload {

    message: InboxMessage;
}

export interface SetPushNotificationPayload {

    message: PushNotification;
}


export const AddInboxMessage: ActionCreatorDefinition<AddInboxMessagePayload, any> = createAction<AddInboxMessagePayload>(AddInboxMessageType);
export const RemoveInboxMessage: ActionCreatorDefinition<RemoveInboxMessagePayload, any> = createAction<RemoveInboxMessagePayload>(RemoveInboxMessageType);
export const ResetInboxUnreadCount: ActionCreatorDefinition<any, any> = createAction<any>(ResetInboxUnreadCountType);
export const SetPushNotification: ActionCreatorDefinition<SetPushNotificationPayload, any> = createAction<any>(SetPushNotificationType);
export const RemovePushNotification: ActionCreatorDefinition<any, any> = createAction<any>(RemovePushNotificationType);